import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/i18n";
import { AuthProvider } from "@/contexts/AuthContext";
import { LookupsProvider } from "@/contexts/LookupsContext";
import Layout from "@/components/layout/Layout";
import ProtectedRoute from "@/components/layout/ProtectedRoute";

import LandingPage from "@/pages/LandingPage";
import OffersListPage from "@/pages/offers/OffersListPage";
import OfferDetailPage from "@/pages/offers/OfferDetailPage";
import CandidatesListPage from "@/pages/candidates/CandidatesListPage";
import CandidateDetailPage from "@/pages/candidates/CandidateDetailPage";
import RegisterPage from "@/pages/auth/RegisterPage";
import LoginPage from "@/pages/auth/LoginPage";
import VerifyEmailPage from "@/pages/auth/VerifyEmailPage";
import ForgotPasswordPage from "@/pages/auth/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/auth/ResetPasswordPage";
import CandidateOnboardingPage from "@/pages/onboarding/CandidateOnboardingPage";
import ProducerOnboardingPage from "@/pages/onboarding/ProducerOnboardingPage";
import CandidateDashboardPage from "@/pages/dashboard/CandidateDashboardPage";
import ProducerDashboardPage from "@/pages/dashboard/ProducerDashboardPage";
import OfferFormPage from "@/pages/dashboard/producer/OfferFormPage";
import AdminPage from "@/pages/admin/AdminPage";
import RoadmapPage from "@/pages/RoadmapPage";
import BlogListPage from "@/pages/blog/BlogListPage";
import BlogPostPage from "@/pages/blog/BlogPostPage";
import CGUVPage from "@/pages/legal/CGUVPage";
import MentionsLegalesPage from "@/pages/legal/MentionsLegalesPage";
import PolitiqueConfidentialitePage from "@/pages/legal/PolitiqueConfidentialitePage";

function App() {
  return (
    <AuthProvider>
      <LookupsProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<LandingPage />} />
              <Route path="offers" element={<OffersListPage />} />
              <Route path="offers/:id" element={<OfferDetailPage />} />
              <Route path="candidates" element={<CandidatesListPage />} />
              <Route path="candidates/:id" element={<CandidateDetailPage />} />
              <Route path="roadmap" element={<RoadmapPage />} />
              <Route path="blog" element={<BlogListPage />} />
              <Route path="blog/:slug" element={<BlogPostPage />} />
              <Route path="cguv" element={<CGUVPage />} />
              <Route path="mentions-legales" element={<MentionsLegalesPage />} />
              <Route path="politique-confidentialite" element={<PolitiqueConfidentialitePage />} />
              <Route path="register" element={<RegisterPage />} />
              <Route path="login" element={<LoginPage />} />
              <Route path="verify-email" element={<VerifyEmailPage />} />
              <Route path="forgot-password" element={<ForgotPasswordPage />} />
              <Route path="reset-password" element={<ResetPasswordPage />} />

              <Route path="onboarding/candidate" element={
                <ProtectedRoute role="candidate"><CandidateOnboardingPage /></ProtectedRoute>
              } />
              <Route path="onboarding/producer" element={
                <ProtectedRoute role="producer"><ProducerOnboardingPage /></ProtectedRoute>
              } />

              <Route path="dashboard/candidate/:tab?" element={
                <ProtectedRoute role="candidate"><CandidateDashboardPage /></ProtectedRoute>
              } />
              <Route path="dashboard/producer/offers/new" element={
                <ProtectedRoute role="producer"><OfferFormPage /></ProtectedRoute>
              } />
              <Route path="dashboard/producer/offers/:id/edit" element={
                <ProtectedRoute role="producer"><OfferFormPage /></ProtectedRoute>
              } />
              <Route path="dashboard/producer/:tab?" element={
                <ProtectedRoute role="producer"><ProducerDashboardPage /></ProtectedRoute>
              } />

              <Route path="admin" element={
                <ProtectedRoute role="admin"><AdminPage /></ProtectedRoute>
              } />
              <Route path="dashboard/admin" element={
                <ProtectedRoute role="admin"><AdminPage /></ProtectedRoute>
              } />
            </Route>
          </Routes>
        </BrowserRouter>
      </LookupsProvider>
    </AuthProvider>
  );
}

export default App;
